export function isRunningInApp() {
  return window.Logout !== undefined;
}

export function isPhoneScreen() {
  const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  const isModernIPad = navigator.userAgent.includes('Macintosh') && isTouch;

  return window.outerWidth < 768 || /iPhone|iPad|iPod|Android/i.test(navigator.userAgent) || isModernIPad;
}

// EZT HASZNÁLD!!
export function isPhoneOrHighScreen() {
  return isPhoneScreen() || window.outerHeight > window.outerWidth;
}
